import { Box, Grid, Typography, Paper } from '@mui/material'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'
import { formatter } from '../../utils/auxFunc'

const VolumeDiscount = ({ conditions, dolarValue }) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="body" gutterBottom>
        Descuentos por Volumen
      </Typography>
      <Grid container spacing={2} justifyContent="space-between" mt={0.2}>
        {conditions.map((condition, index) => (
          <Grid
            item
            xs={12}
            sm={conditions.length > 2 ? 6 : 12 / conditions.length}
            md={conditions.length > 3 ? 4 : 12 / conditions.length}
            key={index}
          >
            <Paper
              variant="outlined"
              sx={{
                py: 1,
                px: 1,
                // textAlign: 'center',
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                height: '100%'
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <LocalOfferIcon />
                <Box sx={{ pl: 1 }}>
                  <Typography variant="body1">
                    <strong>Desde:</strong> {condition.minQuantity} unidades
                  </Typography>
                  <Typography variant="body1">
                    <strong>Precio unitario: </strong>
                    {formatter().format(condition.price * dolarValue)}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default VolumeDiscount
